import React, { MouseEvent, RefObject } from 'react';
import { Index, List } from 'react-virtualized';
import styled from 'styled-components';

import { User } from '@/types/userList';
import { FormValues } from '@/components/pages/Users/Index/UserListForm';

import { Item } from './Item';
import { UserForm } from './UserForm';

const HEADER_ROW_INDEX = 2;
const LIST_HEIGHT = 435;
const LIST_WIDTH = 960;
const OVER_SCAN_ROW_COUNT = 30;

type Props = {
  calcRowHeight: (info: Index) => number;
  hasUpdateError: (userId: number) => boolean;
  isPreview: boolean;
  isUpdating: boolean;
  listRef: RefObject<List>;
  onCancelClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  onEditLinkClick: (e: MouseEvent<HTMLAnchorElement>, userId: number) => void;
  onSubmit: (values: FormValues) => Promise<void>;
  recomputeRowHeights: () => void;
  showUserForm: (index: number) => boolean;
  users: User[];
};

export const VirtualizedList: React.FC<Props> = ({
  calcRowHeight,
  hasUpdateError,
  isPreview,
  isUpdating,
  listRef,
  onCancelClick,
  onEditLinkClick,
  onSubmit,
  recomputeRowHeights,
  showUserForm,
  users,
}) => (
  <Wrapper>
    <List
      height={LIST_HEIGHT}
      overscanRowCount={OVER_SCAN_ROW_COUNT}
      ref={listRef}
      rowCount={users.length}
      rowHeight={calcRowHeight}
      width={LIST_WIDTH}
      rowRenderer={({ index, style }) =>
        showUserForm(index) ? (
          <UserForm
            isUpdating={isUpdating}
            key={index}
            onCancelClick={onCancelClick}
            onSubmit={onSubmit}
            recomputeRowHeights={recomputeRowHeights}
            style={style}
            user={users[index]}
          />
        ) : (
          <Item
            hasError={hasUpdateError(index + HEADER_ROW_INDEX)}
            isPreview={isPreview}
            key={index}
            onEditLinkClick={onEditLinkClick}
            recomputeRowHeights={recomputeRowHeights}
            style={style}
            user={users[index]}
          />
        )
      }
    />
  </Wrapper>
);

const Wrapper = styled.div`
  .ReactVirtualized__List:focus {
    outline: none;
  }
`;
